import { z } from 'zod'
import { ReferentialDomainSchema } from '@/core/infrastructure/schemas/referential/domain/ReferentialDomainSchema.ts'

export const ReferentialAxisSchema = z.object({
  id: z.number(),
  title: z.string(),
  order: z.number(),
  domains: z.array(ReferentialDomainSchema).optional()
})

export const ReferentialAxisListSchema = z.array(ReferentialAxisSchema)

export type ReferentialAxisEntity = z.infer<typeof ReferentialAxisSchema>
export type ReferentialAxisListEntity = z.infer<typeof ReferentialAxisListSchema>
